import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import { SpaPreset } from './app/spa-preset';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { MessageService, ConfirmationService } from 'primeng/api';
import { ES_LOCALE } from './app/locale/es.locale_Version2';
import { EnvConfigService } from './app/services/utils/env-config.service';
import { authInterceptor } from './app/interceptors/auth.interceptor';
import { fechasInterceptor } from './app/interceptors/fechas.interceptor';
import { provideMarkdown } from 'ngx-markdown';
import { LayoutService } from './app/layout/service/layout.service';

function initEnv(envConfigService: EnvConfigService, layoutService: LayoutService) {
  return async () => {
    await envConfigService.loadConfig('app-config');
    // La paleta pública sale del servidor: se aplica antes del primer pintado para evitar parpadeos.
    await layoutService.cargarTemaSitio();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withFetch(), withInterceptors([authInterceptor, fechasInterceptor])),
    EnvConfigService,
    {
        provide: APP_INITIALIZER,
        useFactory: initEnv,
        deps: [EnvConfigService, LayoutService],
        multi: true
    },
    provideRouter(
      appRoutes, 
      withInMemoryScrolling({ 
        anchorScrolling: 'enabled', 
        scrollPositionRestoration: 'enabled' 
      }), 
      withEnabledBlockingInitialNavigation()
    ),
    provideAnimationsAsync(),
    providePrimeNG({ 
      theme: { 
        preset: SpaPreset, 
        options: { 
          darkModeSelector: '.app-dark',
          ripple: true
        } 
      },translation: ES_LOCALE }),
    MessageService,
    ConfirmationService,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    provideAnimationsAsync(),
    provideMarkdown()
  ]
};
